import * as React from 'react';
import { CheckoutModes } from 'modules/checkout/payment/duck/model/PaymentState';

import StripeTabContent from './StripeTabContent';

const TabContentSwitcher = (props) =>
  props.checkoutMode === CheckoutModes.STRIPE_CREDIT_CARD ? <StripeTabContent {...props} /> : null;

export default TabContentSwitcher;
